import { Component, Input } from '@angular/core'
/**
 * VCD Footer
 */
@Component({
  selector: 'ngx-venu-capacity-footer',
  templateUrl: './venu-capacity-footer.component.html',
  styleUrls: ['./venu-capacity-footer.component.scss'],
  standalone: true
})
export class VenuCapacityFooterComponent {
  @Input()
  theme: { enable: boolean; logo: string }
}
